import {
  Box, 
  Typography, 
  TextField, 
  IconButton, 
  Button,
} from '@mui/material';
import { Add, Delete } from '@mui/icons-material';
import FlexBetween from 'components/FlexBetween';
import SectionLabel from 'components/SectionLabel';
import FieldDisplay from 'components/FieldDisplay';


const Contact = ({ 
  values, 
  handleChange, 
  handleBlur, 
  setFieldValue, 
  isEditMode 
}) => {
  const phones = values.contactTel || [];

  const addPhone = () => setFieldValue('contactTel', [...phones, '']);
  const removePhone = (i) => setFieldValue('contactTel', phones.filter((_, idx) => idx !== i));
  const updatePhone = (i, val) => {
    const updated = [...phones];
    updated[i] = val;
    setFieldValue('contactTel', updated);
  };

  if (!isEditMode) return (
    <Box 
      display="grid" 
      gridTemplateColumns="repeat(12, minmax(0, 1fr))" 
      gap={2}
    >
      <Box sx={{ gridColumn: { xs: 'span 6', sm: 'span 6' } }}>
        <FieldDisplay label="Street Address" value={values.address} />
      </Box>
      <Box sx={{ gridColumn: { xs: 'span 4', sm: 'span 2' } }}>
        <FieldDisplay label="City" value={values.city} />
      </Box>
      <Box sx={{ gridColumn: { xs: 'span 4', sm: 'span 2' } }}>
        <FieldDisplay label="State / Province" value={values.state} />
      </Box>
      <Box sx={{ gridColumn: { xs: 'span 4', sm: 'span 2' } }}>
        <FieldDisplay label="ZIP / Postal Code" value={values.zip} />
      </Box>
      <Box sx={{ gridColumn: { xs: 'span 12', sm: 'span 12' } }}>
        <FieldDisplay label="Email" value={values.email} />
      </Box>
      <Box sx={{ gridColumn: { xs: 'span 12', sm: 'span 12' } }}>
        <SectionLabel>Phone Numbers</SectionLabel>
        {phones.length === 0 ? (
          <Typography variant="body2" color="text.secondary">
            No phone numbers recorded.
          </Typography>
        ) : (
          phones.map((tel, i) => (
            <Typography key={i} variant="body2">
              {tel || '-'}
            </Typography>
          ))
        )}
      </Box>
    </Box>
  );

  return (
    <Box 
      display="grid" 
      gridTemplateColumns="repeat(12, minmax(0, 1fr))" 
      gap={2}
    >
      <TextField
        fullWidth 
        size="small" 
        label="Street Address" 
        name="address"
        value={values.address} 
        onChange={handleChange} 
        onBlur={handleBlur}
        sx={{ gridColumn: 'span 12' }}
      />
      <TextField
        fullWidth 
        size="small" 
        label="City" 
        name="city"
        value={values.city} 
        onChange={handleChange}
        onBlur={handleBlur}
        sx={{ gridColumn: { xs: 'span 12', sm: 'span 4' } }}
      />
      <TextField
        fullWidth 
        size="small" 
        label="State / Province" 
        name="state"
        value={values.state} 
        onChange={handleChange}
        onBlur={handleBlur}
        sx={{ gridColumn: { xs: 'span 12', sm: 'span 4' } }}
      />
      <TextField
        fullWidth 
        size="small" 
        label="ZIP / Postal Code" 
        name="zip"
        value={values.zip} 
        onChange={handleChange}
        onBlur={handleBlur}
        sx={{ gridColumn: { xs: 'span 12', sm: 'span 4' } }}
      />
      <TextField
        fullWidth 
        size="small" 
        label="Email" 
        name="email" 
        type="email"
        value={values.email} 
        onChange={handleChange} 
        onBlur={handleBlur}
        sx={{ gridColumn: { xs: 'span 12', sm: 'span 12' } }}
      />

      <Box 
        display="flex" 
        flexDirection="column" 
        gap={1} 
        sx={{ gridColumn: 'span 12' }}
      >
        <FlexBetween>
          <SectionLabel>Phone Numbers</SectionLabel>
          <Button size="small" startIcon={<Add />} onClick={addPhone}>
            Add Phone
          </Button>
        </FlexBetween>

        {phones.length === 0 ? (
          <Typography variant="body2" color="text.secondary">
            No phone numbers recorded.
          </Typography>
        ) : (
          <Box 
            display="flex"
            flexDirection="column"
            gap={2} 
          >
            {phones?.map((tel, i) => (
              <Box 
                key={i} 
                display="flex" 
                alignItems="center" 
                gap={2}
              >
                <TextField
                  fullWidth 
                  size="small" 
                  label={`Phone ${i + 1}`} 
                  value={tel}
                  onChange={(e) => updatePhone(i, e.target.value)}
                  onBlur={handleBlur}
                />
                <IconButton 
                  size="small" 
                  color="error" 
                  onClick={() => removePhone(i)}
                >
                  <Delete fontSize="small" />
                </IconButton>
              </Box>
            ))}
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default Contact;
